import { render, staticRenderFns } from "./health-facility.vue?vue&type=template&id=aa07dd00&scoped=true"
import script from "./health-facility.vue?vue&type=script&lang=js"
export * from "./health-facility.vue?vue&type=script&lang=js"
import style0 from "./health-facility.vue?vue&type=style&index=0&id=aa07dd00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa07dd00",
  null
  
)

export default component.exports